import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

export const getAllPushNotifications = env => {
    return apiCaller
        .call(api.getAllPushNotifications(env))
        .then(({ data }) => {
            if (data.success) {
                return data.pushNotifications;
            }
        })
        .catch(error => {
            Logger.log('dataActions: getAllPushNotifications - ', error);
            throw 'general.error.data_has_not_correctly_returned_by_server';
        });
};
export const getPushNotificationDetails = (env, pushNotificationId) => {
    return apiCaller
        .call(api.getPushNotificationDetails(env, pushNotificationId))
        .then(({ data }) => {
            if (data.success) {
                return data.pushNotificationsDetails[pushNotificationId];
            }
        })
        .catch(error => {
            Logger.log('dataActions: getPushNotificationDetails - ', error);
            throw error;
        });
};
export const updatePushNotification = (env, form, pushNotificationId) => {
    return apiCaller
        .call(api.updatePushNotificationDetails(env, form, pushNotificationId))
        .then(async ({ data }) => {
            if (data.success) {
                return data.pushNotificationsDetails[pushNotificationId];
            }
        })
        .catch(error => {
            Logger.log('dataActions: updatePushNotification - ', error);
            throw error;
        });
};
export const addPushNotification = (env, form) => {
    return apiCaller
        .call(api.addPushNotification(env, form))
        .then(async ({ data }) => {
            if (data.success) {
                return {
                    pushNotification: data.pushNotificationsDetails[data.pushNotificationId],
                    pushNotificationId: data.pushNotificationId
                };
            }
        })
        .catch(error => {
            Logger.log('dataActions: addPushNotification - ', error);
            throw error;
        });
};

export const sendPushNotificationEvent = (env, form) => {
    return getSocketMiddlewareInstance()
        .sendPushNotification(form)
        .then(data => {
            return data.date;
        })
        .catch(error => {
            Logger.log('dataActions: sendPushNotificationEvent - ', error);
            throw error;
        });
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/PushNotifications/actions.js